$(document).on('click', '.user-switcher-icon', function (event) {
  document.querySelector(".user-switcher-panel").classList.toggle('d-none');
});

$(document).on('change', '.user-switcher-panel select', function (event) {
  var form = $(this).closest('form')
  form.submit();
});